<template>
  <div>
    <v-row class="my-2">
      <v-col cols="1">
        <v-btn
          color="primary"
          dark="dark"
          dense="dense"
          block="block"
          @click="$router.push('/vouchers/create')"
          ><span>new</span></v-btn
        >
      </v-col>
      <v-col cols="1">
        <export-excel
          :cost-centers="costCenterIndexList"
          :revenue-sources="revenueSourceIndexList"
        ></export-excel>
      </v-col>
    </v-row>
    <v-data-table
      :items="voucherList"
      :headers="headers"
      single-expand="single-expand"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :server-items-length="voucherGetCount"
      :loading="voucherGetting"
      :sort-by.sync="sortBy"
      dense="dense"
      :sort-desc.sync="sortDesc"
    >
      <template #body.prepend>
        <tr v-if="showTableTop">
          <td :colspan="headers.length">
            <v-row>
              <v-col class="my-1" lg="3" cols="12">
                <v-text-field
                  placeholder="Voucher Details Keywords..."
                  append-icon="mdi-magnify"
                  hide-details="hide-details"
                  outlined="outlined"
                  dense="dense"
                  :clearable="voucherDetailKeyword"
                  v-model="voucherDetailKeyword"
                ></v-text-field>
              </v-col>
            </v-row>
          </td>
        </tr>
      </template>
      <template #header.id
        ><span class="mr-1">Voucher No</span>
        <base-menu-popover-component
          color="blue-grey darken-3"
          title="Filter"
          icon="mdi-filter"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x="offset-x"
        >
          <template #trigger="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs">mdi-filter</v-icon>
          </template>
          <template #content>
            <base-search-combobox v-model="voucherNoFilter"></base-search-combobox>
          </template>
        </base-menu-popover-component>
        <v-icon :color="showTableTop &amp;&amp; 'purple'" @click="showTableTop = !showTableTop"
          >mdi-magnify</v-icon
        >
      </template>
      <template #header.date
        ><span class="mr-1">Date</span>
        <base-menu-popover-component
          color="blue-grey darken-3"
          title="Filter"
          icon="mdi-filter"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x="offset-x"
        >
          <template #trigger="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs">mdi-filter</v-icon>
          </template>
          <template #content>
            <v-row no-gutters="no-gutters">
              <v-col cols="12" lg="6" md="6">
                <v-text-field
                  label="From"
                  dense="dense"
                  hide-details="hide-details"
                  type="date"
                  v-model="dateFrom"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" md="6">
                <v-text-field
                  label="To"
                  dense="dense"
                  hide-details="hide-details"
                  type="date"
                  v-model="dateTo"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
        </base-menu-popover-component>
      </template>
      <template #header.created_by
        ><span class="mr-1">Requestor</span>
        <base-menu-popover-component
          color="blue-grey darken-3"
          title="Filter"
          icon="mdi-filter"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x="offset-x"
        >
          <template #trigger="{ on, attrs }">
            <v-btn text="text" small="small" v-on="on" v-bind="attrs">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <template #content>
            <base-search-combobox v-model="requestorFilter"></base-search-combobox>
          </template>
        </base-menu-popover-component>
      </template>
      <template #header.pay_to
        ><span class="mr-1">Pay to</span>
        <base-menu-popover-component
          color="blue-grey darken-3"
          title="Filter"
          icon="mdi-filter"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x="offset-x"
        >
          <template #trigger="{ on, attrs }">
            <v-btn text="text" small="small" v-on="on" v-bind="attrs">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <template #content>
            <base-search-combobox v-model="payToFilter"></base-search-combobox>
          </template>
        </base-menu-popover-component>
      </template>
      <template #header.approved_rejected_by
        ><span class="mr-1">Approve / Reject</span>
        <base-tooltip
          text="text"
          x-small="x-small"
          :color="showSelfApprovedRejected ? 'purple' : 'blue-grey darken-2'"
          :tooltip="
            showSelfApprovedRejected ? 'Show everything' : 'Show only your aproved or rejected'
          "
          bottom="bottom"
          @click="showSelfApprovedRejected = !showSelfApprovedRejected"
        >
          <v-icon>mdi-filter</v-icon>
        </base-tooltip>
      </template>
      <template #header.paid_by
        ><span class="mr-1">Paid by</span>
        <base-menu-popover-component
          color="blue-grey darken-3"
          title="Filter"
          icon="mdi-filter"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x="offset-x"
        >
          <template #trigger="{ on, attrs }">
            <v-btn text="text" small="small" v-on="on" v-bind="attrs">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <template #content>
            <v-autocomplete
              label="search"
              append-icon="mdi-magnify"
              multiple="multiple"
              small-chips="small-chips"
              v-model="paidByFilter"
              :items="revenueSourceIndexList"
              item-value="id"
              item-text="code"
              clearable="clearable"
              :filter="autocompleteFilter"
            >
              <template #item="{ item }"
                ><span class="mr-2 primary--text">{{ item.code }}</span
                ><small class="blue-grey--text">{{ item.description }}</small></template
              >
            </v-autocomplete>
          </template>
        </base-menu-popover-component>
      </template>
      <template #header.cost_center_id
        ><span class="mr-1">Cost Center</span>
        <base-menu-popover-component
          color="blue-grey darken-3"
          title="Filter"
          icon="mdi-filter"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x="offset-x"
        >
          <template #trigger="{ on, attrs }">
            <v-btn text="text" small="small" v-on="on" v-bind="attrs">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <template #content>
            <v-autocomplete
              label="search"
              append-icon="mdi-magnify"
              multiple="multiple"
              small-chips="small-chips"
              v-model="costCenterFilter"
              :items="costCenterIndexList"
              item-value="id"
              item-text="code"
              clearable="clearable"
              :filter="autocompleteFilter"
            >
              <template #item="{ item }"
                ><span class="mr-2 primary--text">{{ item.code }}</span
                ><small class="blue-grey--text">{{ item.description }}</small></template
              >
            </v-autocomplete>
          </template>
        </base-menu-popover-component>
      </template>
      <template #item="{ item, expand, isExpanded }">
        <tr>
          <td>
            <v-btn
              color="info"
              x-small="x-small"
              dense="dense"
              text="text"
              @click="openInfoDialog(item)"
            >
              <v-icon>mdi-information-outline</v-icon> </v-btn
            ><span>{{ item.voucher_no }}</span>
          </td>
          <td>{{ item.cost_center.code }}</td>
          <td>{{ item.pay_to.name }}</td>
          <td>{{ item.created_by ? item.created_by.name : null }}</td>
          <td>{{ item.date.dateFormat() }}</td>
          <td>{{ item.paid_by.code }}</td>
          <td class="text-uppercase" :class="approvedRejectedColor(item.status)">
            {{ item.status.description }}
          </td>
          <td class="text-right">{{ paidAmount(item.transactions).phpFormat() }}</td>
          <td class="text-center">
            <v-btn
              v-if="!item.approved_rejected_by &amp;&amp; allowedForApproval"
              color="success"
              text="text"
              small="small"
              dense="dense"
              @click="approveVoucher(item.id)"
              :loading="approveVoucherPosting"
              ><span>Approve</span></v-btn
            >
            <v-btn
              v-if="!item.approved_rejected_by &amp;&amp; allowedForApproval"
              color="error"
              text="text"
              small="small"
              dense="dense"
              @click="rejectVoucher(item.id)"
              :loading="rejectVoucherPosting"
              ><span>Reject</span></v-btn
            ><span v-else :class="approvedRejectedColor(item.status)">{{
              item.approved_rejected_by ? item.approved_rejected_by.name : null
            }}</span>
          </td>
          <td class="text-right">
            <base-tooltip
              v-if="'AP' === item.voucher_status_id"
              bottom="bottom"
              color="green"
              no-btn="no-btn"
              tooltip="COMPLETE VOUCHER"
            >
              <template v-slot="{ on, loading, isLoading }">
                <v-icon
                  v-on="on"
                  color="green"
                  @click="completeVoucher(item.id, loading, isLoading)"
                  >mdi-check</v-icon
                >
              </template>
            </base-tooltip>
            <v-tooltip
              v-if="['NW', 'RJ'].includes(item.voucher_status_id)"
              bottom="bottom"
              color="yellow darken-2"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-on="on"
                  color="yellow darken-2"
                  @click="$router.push({ name: 'vouchers.edit', params: { voucherId: item.id } })"
                  >mdi-pencil</v-icon
                > </template
              ><span>edit</span>
            </v-tooltip>
            <v-btn
              icon
              small
              @click="
                $router.push({
                  name: 'vouchers.receipt-attachments',
                  params: { voucherId: item.id },
                })
              "
            >
              <v-icon color="blue">mdi-paperclip</v-icon>
            </v-btn>

            <v-tooltip
              v-if="item.approved_rejected_by &amp;&amp; item.voucher_status_id !== 'RJ'"
              color="primary"
              bottom="bottom"
              dark="dark"
            >
              <template #activator="{ on }">
                <v-icon v-on="on" color="primary" @click="openVoucherChequeDialog(item)"
                  >mdi-checkbook</v-icon
                > </template
              ><span>Transactions</span>
            </v-tooltip>
            <base-tooltip
              v-if="!['NW', 'RJ'].includes(item.voucher_status_id)"
              color="red"
              dark="dark"
              bottom="bottom"
              tooltip="Print PDF"
              no-btn="no-btn"
            >
              <template v-slot="{ on, loading, isLoading }">
                <v-icon v-on="on" color="red" @click="printPdf(item.id, loading, isLoading)"
                  >mdi-note-text</v-icon
                >
              </template>
            </base-tooltip>
            <v-tooltip
              v-if="item.approved_rejected_by &amp;&amp; item.voucher_status_id !== 'RJ'"
              bottom="bottom"
              color="green"
              dark="dark"
            >
              <template #activator="{ on }">
                <v-icon
                  v-on="on"
                  color="green"
                  @click="
                    $router.push({
                      name: 'vouchers.petty-cash.manage',
                      params: { voucherId: item.id },
                    })
                  "
                  >mdi-note-text</v-icon
                > </template
              ><span>Petty Cash Voucher</span>
            </v-tooltip>
            <v-icon
              :class="isExpanded ? 'is-expanded' : ''"
              color="blue-grey darken-3"
              @click="expand(!isExpanded)"
              >mdi-chevron-down</v-icon
            >
          </td>
        </tr>
      </template>
      <template #expanded-item="{ item }">
        <tr>
          <td colspan="6">
            <v-toolbar color="purple" dark="dark" dense="dense" flat="flat"
              ><span>Details</span></v-toolbar
            >
            <v-simple-table dense="dense">
              <template #default>
                <thead>
                  <tr>
                    <th class="text-center" width="100">Acct</th>
                    <th class="text-left">Desc.</th>
                    <th>Reason</th>
                    <th class="text-right">Amnt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in item.details" :key="item.id">
                    <td class="text-center">{{ item.account_code.account_code }}</td>
                    <td
                      class="text-left"
                      v-html="hightLightKeyword(item.account_code.description)"
                    ></td>
                    <td v-html="hightLightKeyword(item.reason)"></td>
                    <td class="text-right">{{ (item.amount || 0).phpFormat() }}</td>
                  </tr>
                  <tr>
                    <th class="text-left" colspan="3">Total</th>
                    <td class="text-right">{{ totalAmount(item.details).phpFormat() }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
          <td colspan="4">
            <v-toolbar color="green" dark="dark" dense="dense" flat="flat"
              ><span>Acct Codes</span></v-toolbar
            >
            <v-simple-table dense="dense">
              <template #default>
                <thead>
                  <tr>
                    <th>Acct</th>
                    <th class="text-right">Dis. Amnt</th>
                    <th class="text-right">Amnt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in item.account_codes" :key="item.id">
                    <td>{{ item.account_code.account_code }}</td>
                    <td class="text-right">{{ (item.disbursed_amount || 0).phpFormat() }}</td>
                    <td class="text-right">{{ item.amount.phpFormat() }}</td>
                  </tr>
                  <tr v-if="item.revolving_fund">
                    <td>--.--</td>
                    <td class="text-right">
                      {{ (item.revolving_fund.disbursed_amount || 0).phpFormat() }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <td class="text-right">
                      <span
                        :class="totalAmount(item.account_codes) &lt; totalDisbursedAmount(item.account_codes, item.revolving_fund) ? 'red--text' : ''"
                        >{{
                          totalDisbursedAmount(item.account_codes, item.revolving_fund).phpFormat()
                        }}</span
                      >
                    </td>
                    <td class="text-right">{{ totalAmount(item.account_codes).phpFormat() }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </tr>
      </template>
    </v-data-table>
    <voucher-transaction :voucher="voucher" v-model="voucherChequeDialog"></voucher-transaction>
    <voucher-info
      v-model="showInfo"
      :data="voucher"
      :approving="approveVoucherPosting"
      :rejecting="rejectVoucherPosting"
      @approve="approveVoucher"
      @reject="rejectVoucher"
    ></voucher-info></div
></template>
<style lang="sass" scoped>
.is-expanded
  transform: rotate(-180deg)
</style>
<script>
import voucherRepository from '@/repositories/voucher.repository'
import costCenterRepository from '@/repositories/cost-center.repository'
import revenueSourceRepository from '@/repositories/revenue-source.repository'
import VueRequestHandler from '@/libs/classes/VueRequestHandler.class'
import { requestVars } from '@/libs/api-helper.extra'

const [voucherGetVars, voucherGetVarNames] = requestVars({
  identifier: 'voucher',
  pagination: true,
})
const [approveVoucherVars, approveVoucherVarNames] = requestVars({
  identifier: 'approve-voucher',
  hasData: false,
  request: 'post',
})
const [rejectVoucherVars, rejectVoucherVarNames] = requestVars({
  identifier: 'reject-voucher',
  hasData: false,
  request: 'post',
})
const [voucherPrintPdfVars, voucherPrintPdfVarNames] = requestVars({
  identifier: 'voucher-print-pdf',
  hasData: false,
  request: 'get',
})
const [costCenterIndexVars, costCenterIndexVarnames] = requestVars({
  identifier: 'cost-center-index',
})
const [revenueSourceIndexVars, revenueSourceIndexVarNames] = requestVars({
  identifier: 'revenue-source-index',
})
const [voucherCompleteVars, voucherCompleteVarNames] = requestVars({
  identifier: 'voucher-complete',
  hasData: false,
  hasLoading: false,
  request: 'post',
})

const voucherGetHandler = new VueRequestHandler(null, voucherGetVarNames, {}, true)
const approveVoucherHandler = new VueRequestHandler(null, approveVoucherVarNames)
const rejectVoucherHandler = new VueRequestHandler(null, rejectVoucherVarNames)
const voucherPrintPdfHandler = new VueRequestHandler(null, voucherPrintPdfVarNames)
const costCenterIndexHandler = new VueRequestHandler(null, costCenterIndexVarnames)
const revenueSourceIndexHandler = new VueRequestHandler(null, revenueSourceIndexVarNames)
const voucherCompleteHandler = new VueRequestHandler(null, voucherCompleteVarNames)

const tableVars = () => ({
  headers: [
    { text: 'Voucher No.', value: 'id', divider: true, sortable: false },
    { text: 'Cost Center', value: 'cost_center_id', divider: true, sortable: false },
    { text: 'Pay To', value: 'pay_to', divider: true, sortable: false },
    { text: 'Requestor', value: 'created_by', divider: true, sortable: false },
    { text: 'Date', value: 'date', divider: true, sortable: false },
    { text: 'Paid By', value: 'paid_by', divider: true, sortable: false },
    { text: 'Status', value: 'voucher_status_id', divider: true },
    { text: 'Paid Amnt', sortable: false, divider: true },
    {
      text: 'Approved / Rejected By',
      value: 'approved_rejected_by',
      divider: true,
      sortable: false,
    },
    { text: 'Config', sortable: false },
  ],
  page: 1,
  itemsPerPage: 10,
  sortBy: '',
  sortDesc: false,
  voucherId: null,
  voucherChequeDialog: false,
  showInfo: false,
  showSelfApprovedRejected: false,
  voucherNoFilter: [],
  payToMenu: false,
  payToFilter: [],
  costCenterFilter: [],
  paidByFilter: [],
  requestorFilter: [],
  dateFrom: null,
  dateTo: Window.getCurrentDate(),
  showTableTop: false,
  voucherDetailKeyword: null,
})

export default {
  name: 'TableVoucher',
  components: {
    voucherTransaction: () => import('./transactions/Index'),
    voucherInfo: () => import('./Show'),
    exportExcel: () => import('./ExportExcel'),
  },
  data() {
    return {
      ...tableVars(),
      ...voucherGetVars,
      ...approveVoucherVars,
      ...rejectVoucherVars,
      ...voucherPrintPdfVars,
      ...costCenterIndexVars,
      ...revenueSourceIndexVars,
      ...voucherCompleteVars,
    }
  },
  created() {
    this.getVouchers()
    this.initWebsocket()
    this.getCostCenters()
    this.getRevenueSources()
  },
  computed: {
    voucher() {
      if (!this.voucherId) return {}
      return this.voucherList.find(item => item.id === this.voucherId)
    },
    allowedForApproval() {
      return this.$store.state.auth.accessLevel > 5
    },
    getVoucherIndexParams() {
      const { page, itemsPerPage } = this
      return {
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        voucherNo: this.voucherNoFilter.join(','),
        payTo: this.payToFilter.join(','),
        costCenter: this.costCenterFilter.join(','),
        paidBy: this.paidByFilter.join(','),
        requestor: this.requestorFilter.join(','),
        vdKeywords: this.voucherDetailKeyword,
        sar: this.showSelfApprovedRejected,
      }
    },
  },
  watch: {
    voucherNoFilter() {
      this.page = 1
    },
    getVoucherIndexParams() {
      this.getVouchers()
    },
    voucherDetailKeyword() {
      this.page = 1
    },
  },
  methods: {
    async printPdf(voucherId, loading, isLoading) {
      if (isLoading) return
      loading(true)
      const handler = voucherPrintPdfHandler
      const repository = voucherRepository.printPdf
      handler.setVue(this)
      try {
        const { data } = await handler.execute(repository, [voucherId])
        const blob = new Blob([data.decodeBase64()], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.target = '__blank'
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (e) {
        alert(e.message)
      } finally {
        loading(false)
      }
    },
    openInfoDialog(item) {
      this.voucherId = item.id
      this.showInfo = true
    },
    openVoucherChequeDialog(item) {
      this.voucherId = item.id
      this.voucherChequeDialog = true
    },
    rejectVoucher(id) {
      this.$confirm('Are you sure you want to reject this voucher?', {
        title: 'Reject',
        color: 'error',
        icon: 'mdi-alert',
      }).then(result => {
        if (!result) return
        const handler = rejectVoucherHandler
        const repository = voucherRepository.reject
        handler.setVue(this)
        handler.execute(repository, [id])
      })
    },
    initWebsocket() {
      const { echo } = this.$store.state.websocket
      echo.private('database.event').listen('DBUpdateEvent', this.dbUpdateEvent)
    },
    dbUpdateEvent({ model, data }) {
      if (!model && this.$objectEmpty(data)) return
      if (model === 'CostCenter') {
        this.costCenterIndexList.push(data)
        return
      }
      if (model === 'RevenueSource') {
        this.revenueSourceIndexList.push(data)
        return
      }
      if (model === 'Voucher') {
        this.voucherList = this.voucherList.map(item => {
          if (data.id === item.id) {
            return { ...item, ...data }
          }
          return { ...item }
        })
      }
    },
    approveVoucher(id) {
      this.$confirm('Are you sure you want to approve this voucher ?', {
        title: 'Approve',
        color: 'success',
        icon: 'mdi-check',
      }).then(confirm => {
        if (!confirm) return
        const handler = approveVoucherHandler
        const repository = voucherRepository.approve
        handler.setVue(this)
        handler.execute(repository, [id])
      })
    },
    getVouchers() {
      const handler = voucherGetHandler
      const repository = voucherRepository.index
      const params = this.getVoucherIndexParams
      handler.setVue(this)
      handler.execute(repository, [params])
    },
    convertToVoucherNo({ id }) {
      const voucherNo = id.toString().padStart(7, '0')
      return `V${voucherNo}`
    },
    approvedRejectedColor(args) {
      const { id = null } = args || {}
      if (id === 'AP') return 'green--text'
      if (id === 'RJ') return 'red--text'
      return null
    },
    totalAmount(items) {
      return items.reduce((total, item) => total + item.amount, 0)
    },
    totalBalance(items) {
      return items.reduce((total, item) => item.balance + total, 0)
    },
    totalDisbursedAmount(items, revFund) {
      const disbursedAmount = items.reduce(
        (total, item) => Number(item.disbursed_amount) + total,
        0
      )
      return revFund ? revFund.disbursed_amount + disbursedAmount : disbursedAmount
    },
    getCostCenters() {
      const handler = costCenterIndexHandler
      const repository = costCenterRepository.index
      handler.setVue(this)
      handler.execute(repository)
    },
    getRevenueSources() {
      const handler = revenueSourceIndexHandler
      const repository = revenueSourceRepository.index
      handler.setVue(this)
      handler.execute(repository)
    },
    autocompleteFilter(item, queryText) {
      const regEx = new RegExp(queryText, 'i')
      return regEx.test(item.code) || regEx.test(item.description)
    },
    paidAmount(transactions) {
      return transactions.reduce((total, item) => total + item.amount, 0)
    },
    async completeVoucher(id, loading, isLoading) {
      const confirm = await this.$confirm('are you sure you want to complete this voucher?')
      if (!confirm) return
      if (isLoading) return
      loading(true)
      const handler = voucherCompleteHandler
      const repository = voucherRepository.complete
      handler.setVue(this)
      try {
        const result = await handler.execute(repository, [id])
      } catch (e) {
        alert(e.message)
      } finally {
        loading(false)
      }
    },
    hightLightKeyword(reason) {
      const keyword = this.voucherDetailKeyword

      if (!keyword) return reason
      const regex = new RegExp(keyword, 'ig')
      const result = reason.replace(
        regex,
        word => `<span style="background:#FFEB3B;"><strong>${word}</strong></span>`
      )

      return result
    },
  },
  mixins: [require('@/views/admin/vouchers/account-codes/mixin').default],
}
</script>
